import AuctionList from "./AuctionList";

export default AuctionList;
